// UI-only admin allowlist. This controls visibility of /admin/keys — the
// actual enforcement happens server-side in functions/src/lib/auth.ts
// (requireAdmin), which is the only layer that matters for security.
// Keep both lists in sync. Fill in your own Firebase Auth UID after you
// sign in once; read it from the Firebase console → Authentication → Users.
export const ADMIN_UIDS: string[] = [
  'ooGskZz19caeLiHC8gT9xEvT8Zw2',
]

export function isAdminUid(uid: string | null | undefined): boolean {
  if (!uid) return false
  return ADMIN_UIDS.includes(uid)
}
